<template>
  <div class="login-page">
    <v-card class="login-card" elevation="4">
      <v-card-text class="login-card__content">
        <div class="login-card__logo-wrapper">
          <img src="../assets/logo-kiratik.png" alt="KIRATIK Logo" class="login-card__logo" />
        </div>
        <h1 class="login-card__app-name" data-testid="login-title">License Manager</h1>
        <v-form @submit.prevent="login" data-testid="login-form">
          <v-text-field
            data-testid="input-email-form"
            outlined
            hide-details
            label="Email or username"
            name="username"
            v-model="email"
            append-icon="mdi-email-outline"
            class="login-card__input"
          />
          <v-text-field
            data-testid="input-password-form"
            outlined
            hide-details
            label="Password"
            type="password"
            name="password"
            v-model="password"
            append-icon="mdi-lock-outline"
            class="login-card__input login-card__input--last"
          />
          <v-btn
            type="submit"
            block
            color="#ADCE6D"
            class="login-card__button white--text"
            :disabled="!isFormValid"
          >
            LOG IN
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
    <div class="login-page__version">
      <DisplayVersion></DisplayVersion>
    </div>
  </div>
</template>

<script>
// https://www.pusher.com/tutorials/authentication-vue-vuex/
import Vue from 'vue';
import DisplayVersion from '../components/layouts/DisplayVersion.vue';

export default Vue.extend({
  components: {
    DisplayVersion,
  },
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      appName: process.env.VUE_APP_NAME,
    };
  },
  computed: {
    isFormValid() {
      return this.email.trim() !== '' && this.password.trim() !== '';
    },
  },
  methods: {
    login() {
      const axios = this.$http;
      const { email, password } = this;
      this.$store
        .dispatch('auth/login', { email, password, axios })
        .then(() => {
          this.$router.push('/customers');
        })
        .catch(() => {
          this.$store.commit('setPopupAlert', {
            title: 'Login Failed',
            message: 'Invalid login credentials. Please try again.',
            color: 'error',
          });
        });
    },
  },
});
</script>

<style lang="scss" scoped>
  .login-page {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: none;
    position: relative;
    flex: 1;

    &__version {
      position: absolute;
      bottom: 20px;
      left: 0;
      right: 0;
      text-align: center;
    }
  }

  .login-card {
    width: 100%;
    max-width: 380px;
    border-radius: 24px !important;

    &__content {
      padding: 48px 32px;
    }

    &__logo-wrapper {
      display: flex;
      justify-content: center;
      margin-bottom: 16px;
    }

    &__logo {
      max-width: 220px;
      height: auto;
    }

    &__app-name {
      font-size: 1.5rem;
      font-weight: 400;
      color: #333;
      text-align: center;
      margin-top: 0;
      margin-bottom: 48px;
    }

    &__input {
      margin-bottom: 16px !important;

      &--last {
        margin-bottom: 16px !important;
      }

      ::v-deep .v-input__slot {
        min-height: 48px !important;
        align-items: center;
      }

      ::v-deep .v-text-field__slot {
        align-items: center;
      }

      ::v-deep .v-label {
        top: 50% !important;
        transform: translateY(-50%);
      }

      ::v-deep .v-label--active {
        top: 0 !important;
        transform: translateY(-12px) scale(0.75);
      }

      ::v-deep .v-input__append-inner {
        margin-top: 0 !important;
        align-self: center;
      }
    }

    &__button {
      margin-top: 0;
      font-weight: 600;
      letter-spacing: 1px;
      height: 44px !important;
    }
  }
</style>
